import { render, staticRenderFns } from "./TopluIslerView.vue?vue&type=template&id=a4e7aa84&scoped=true"
import script from "./TopluIslerView.vue?vue&type=script&lang=ts"
export * from "./TopluIslerView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e7aa84",
  null
  
)

export default component.exports